import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Elementsfsk() {
  return (
    <div className="elements_fsk p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>
              <span>Elements</span>
            </h2>
            <div className="elements_img_1">
              <StaticImage
                src="../../../images/case-studies/fsk/elements-img-1.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1322}
                height={230}
              />
            </div>
            <div className="elements_img_2">
              <StaticImage
                src="../../../images/case-studies/fsk/elements_second.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1279}
                height={361}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Elementsfsk;
